
export const LEVEL_UP_FALLBACK_LIFETIME_MS = 1_800;

export interface LevelUpScreenPoint {
  readonly x: number;
  readonly y: number;
}

export interface LevelUpVisual {
  readonly alpha: number;
  readonly phase: number;
}

export function levelUpVisual(bornMs: number, nowMs: number): LevelUpVisual {
  const age = nowMs - bornMs;
  if (age <= 0) return { alpha: 1, phase: 0 };
  if (age >= LEVEL_UP_FALLBACK_LIFETIME_MS) return { alpha: 0, phase: 1 };
  const phase = age / LEVEL_UP_FALLBACK_LIFETIME_MS;
  return { alpha: phase > 0.72 ? 1 - (phase - 0.72) / 0.28 : 1, phase };
}

type LevelUpFallbackContext = Pick<
  CanvasRenderingContext2D,
  "save" | "restore" | "beginPath" | "arc" | "moveTo" | "lineTo" | "stroke"
> & {
  globalAlpha: number;
  strokeStyle: CanvasRenderingContext2D["strokeStyle"];
  lineWidth: number;
};

/** Draw the warm root ring and eight rays rising toward the actor's chest. */
export function drawLevelUpFallback(
  ctx: LevelUpFallbackContext,
  base: LevelUpScreenPoint,
  top: LevelUpScreenPoint,
  visual: LevelUpVisual,
): void {
  if (visual.alpha <= 0) return;
  const radius = 8 + visual.phase * 24;
  const risingY = base.y + (top.y - base.y) * visual.phase;

  ctx.save();
  ctx.globalAlpha = visual.alpha * 0.9;
  ctx.strokeStyle = "#ffd45e";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(base.x, base.y, radius, 0, Math.PI * 2);
  for (let ray = 0; ray < 8; ray += 1) {
    const angle = (ray / 8) * Math.PI * 2;
    const inner = radius * 1.1;
    const outer = radius * 1.55;
    ctx.moveTo(base.x + Math.cos(angle) * inner, base.y + Math.sin(angle) * inner);
    ctx.lineTo(base.x + Math.cos(angle) * outer, base.y + Math.sin(angle) * outer);
  }
  ctx.stroke();

  ctx.globalAlpha = visual.alpha;
  ctx.strokeStyle = "#fff3b0";
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(base.x, base.y);
  ctx.lineTo(base.x, risingY);
  ctx.stroke();
  ctx.restore();
}
